import { Stage } from "./vendor/stageshow/kit/stage"
import { Window, Bar } from "./vendor/stageshow/kit/window"
import type { Act } from "./vendor/stageshow/kit/act"
import "./story.css"

const initial = { prefix: "", focused: false, sent: false }
const poster = { prefix: "podpod.me/", focused: false, sent: true }

async function addPrefix(a: Act<typeof initial>) {
  await a.wait(700)
  await a.move("address")
  await a.click()
  await a.set({ focused: true })
  await a.type("prefix", "podpod.me/", { interval: 120 })
  await a.wait(600)
  await a.key("Enter")
  await a.set({ focused: false, sent: true })
}

export function PrefixDemo() {
  return (
    <Stage
      width={358}
      height={180}
      initial={initial}
      poster={poster}
      script={addPrefix}
      play="once"
      className="prefix-demo"
      cursor={{ at: { x: 258, y: 112 } }}
    >
      {(s) => (
        <Window
          className="article-browser"
          url={
            <span data-cursor="ibeam" data-target="address" className="demo-address">
              <b>{s.prefix}</b>
              {s.focused && <i />}theconversation.com/…
            </span>
          }
        >
          <div className="article-snippet">
            <small>The Conversation</small>
            <strong>Why is it so difficult to make a new antibiotic?</strong>
            <Bar w="84%" h={4} />
            <Bar w="65%" h={4} />
          </div>
          <div className="sent-slip" data-sent={s.sent}>
            Added to Podpod
          </div>
        </Window>
      )}
    </Stage>
  )
}
